import React from "react";
import "react-phone-input-2/lib/style.css"; // Import styles
import "./UserRequest.css";
import PublicHeader from "../../components/public/PublicHeader";
import PublicFooter from "../../components/public/PublicFooter";

const UserRequest = () => {

    return (
        <div className="user-request-container">
            <PublicHeader />
            <section className="public-hero">
                <div className="public-container">
                    <section className="user-request-header">
                        <div className="header-content">
                            <h1>User Requests</h1>
                            <p>Fill the form below to request account changes or deletion. We'll get back to you within 24 hours.</p>
                        </div>
                    </section>
                </div>
            </section>

            <div className="user-request-content">
                <div className="form-container">
                    <iframe
                        title="User Requests"
                        aria-label="User Requests"
                        frameBorder="0"
                        style={{ height: '500px', width: '99%', border: 'none' }}
                        src="https://forms.zohopublic.in/connectzi1/form/UserRequests/formperma/tl7Grc0WnNV1LJXUfGfQRzMd7auiKyqeWFpbleHRgPk"
                    />
                </div>
            </div>
            <PublicFooter />
        </div>
    );
};

export default UserRequest;

